// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2lLmS","bigColWidth":"Table_bigColWidth__14DDP","biggerColWidth":"Table_biggerColWidth__28h13","row":"Table_row__bLWkw","col":"Table_col__3iSpR"};